import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// Platform is locked to dark mode by product decision.
// We do not offer a light/dark toggle in the UI — the visual design
// (gradients, glow, contrast) is built for the dark canvas.
export const ThemeProvider = ({ children }) => {
  const theme = 'dark';

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light');
    root.classList.add('dark');
    try { localStorage.setItem('theme', 'dark'); } catch (_e) { /* storage blocked */ }
  }, []);

  // setTheme / toggleTheme kept as no-ops so existing callers don't crash.
  const setTheme = () => {};
  const toggleTheme = () => {};

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
